export default `
html[data-color-mode="light"][data-theme~="light:dark"],
html[data-color-mode="dark"][data-theme~="dark:dark"] {
  color-scheme: dark;
  --ds-text: #B6C2CF;
  --ds-text-accent-lime: #B3DF72;
  --ds-text-accent-lime-bolder: #D3F1A7;
  --ds-text-accent-red: #FD9891;
  --ds-text-accent-red-bolder: #FFD5D2;
  --ds-text-accent-orange: #FEC195;
  --ds-text-accent-orange-bolder: #FEDEC8;
  --ds-text-accent-yellow: #F5CD47;
  --ds-text-accent-yellow-bolder: #F8E6A0;
  --ds-text-accent-green: #7EE2B8;
  --ds-text-accent-green-bolder: #BAF3DB;
  --ds-text-accent-teal: #9DD9EE;
  --ds-text-accent-teal-bolder: #C6EDFB;
  --ds-text-accent-blue: #85B8FF;
  --ds-text-accent-blue-bolder: #CCE0FF;
  --ds-text-accent-purple: #B8ACF6;
  --ds-text-accent-purple-bolder: #DFD8FD;
  --ds-text-accent-magenta: #F797D2;
  --ds-text-accent-magenta-bolder: #FDD0EC;
  --ds-text-accent-gray: #9FADBC;
  --ds-text-accent-gray-bolder: #DEE4EA;
  --ds-text-disabled: #BFDBF847;
  --ds-text-inverse: #1D2125;
  --ds-text-selected: #579DFF;
  --ds-text-brand: #579DFF;
  --ds-text-danger: #FD9891;
  --ds-text-warning: #F5CD47;
  --ds-text-warning-inverse: #1D2125;
  --ds-text-success: #7EE2B8;
  --ds-text-discovery: #B8ACF6;
  --ds-text-information: #85B8FF;
  --ds-text-subtlest: #8C9BAB;
  --ds-text-subtle: #9FADBC;
  --ds-link: #579DFF;
  --ds-link-pressed: #85B8FF;
  --ds-link-visited: #B8ACF6;
  --ds-link-visited-pressed: #DFD8FD;
  --ds-icon: #9FADBC;
  --ds-icon-accent-lime: #82B536;
  --ds-icon-accent-red: #E2483D;
  --ds-icon-accent-orange: #F38A3F;
  --ds-icon-accent-yellow: #F5CD47;
  --ds-icon-accent-green: #2ABB7F;
  --ds-icon-accent-teal: #42B2D7;
  --ds-icon-accent-blue: #388BFF;
  --ds-icon-accent-purple: #8F7EE7;
  --ds-icon-accent-magenta: #DA62AC;
  --ds-icon-accent-gray: #738496;
  --ds-icon-disabled: #BFDBF847;
  --ds-icon-inverse: #1D2125;
  --ds-icon-selected: #579DFF;
  --ds-icon-brand: #579DFF;
  --ds-icon-danger: #F15B50;
  --ds-icon-warning: #F5CD47;
  --ds-icon-warning-inverse: #1D2125;
  --ds-icon-success: #2ABB7F;
  --ds-icon-discovery: #8F7EE7;
  --ds-icon-information: #388BFF;
  --ds-icon-subtle: #8C9BAB;
  --ds-border: #A6C5E229;
  --ds-border-accent-lime: #82B536;
  --ds-border-accent-red: #F15B50;
  --ds-border-accent-orange: #F38A3F;
  --ds-border-accent-yellow: #CF9F02;
  --ds-border-accent-green: #2ABB7F;
  --ds-border-accent-teal: #42B2D7;
  --ds-border-accent-blue: #388BFF;
  --ds-border-accent-purple: #8F7EE7;
  --ds-border-accent-magenta: #DA62AC;
  --ds-border-accent-gray: #738496;
  --ds-border-disabled: #A1BDD914;
  --ds-border-focused: #85B8FF;
  --ds-border-input: #738496;
  --ds-border-inverse: #161A1D;
  --ds-border-selected: #579DFF;
  --ds-border-brand: #579DFF;
  --ds-border-danger: #F15B50;
  --ds-border-warning: #CF9F02;
  --ds-border-success: #2ABB7F;
  --ds-border-discovery: #8F7EE7;
  --ds-border-information: #388BFF;
  --ds-border-bold: #738496;
  --ds-background-accent-lime-subtlest: #28311B;
  --ds-background-accent-lime-subtlest-hovered: #37471F;
  --ds-background-accent-lime-subtlest-pressed: #4C6B1F;
  --ds-background-accent-lime-subtler: #37471F;
  --ds-background-accent-lime-subtler-hovered: #4C6B1F;
  --ds-background-accent-lime-subtler-pressed: #5B7F24;
  --ds-background-accent-lime-subtle: #4C6B1F;
  --ds-background-accent-lime-subtle-hovered: #37471F;
  --ds-background-accent-lime-subtle-pressed: #28311B;
  --ds-background-accent-lime-bolder: #94C748;
  --ds-background-accent-lime-bolder-hovered: #B3DF72;
  --ds-background-accent-lime-bolder-pressed: #D3F1A7;
  --ds-background-accent-red-subtlest: #42221F;
  --ds-background-accent-red-subtlest-hovered: #5D1F1A;
  --ds-background-accent-red-subtlest-pressed: #AE2E24;
  --ds-background-accent-red-subtler: #5D1F1A;
  --ds-background-accent-red-subtler-hovered: #AE2E24;
  --ds-background-accent-red-subtler-pressed: #C9372C;
  --ds-background-accent-red-subtle: #AE2E24;
  --ds-background-accent-red-subtle-hovered: #5D1F1A;
  --ds-background-accent-red-subtle-pressed: #42221F;
  --ds-background-accent-red-bolder: #F87168;
  --ds-background-accent-red-bolder-hovered: #FD9891;
  --ds-background-accent-red-bolder-pressed: #FFD5D2;
  --ds-background-accent-orange-subtlest: #38291E;
  --ds-background-accent-orange-subtlest-hovered: #702E00;
  --ds-background-accent-orange-subtlest-pressed: #A54800;
  --ds-background-accent-orange-subtler: #702E00;
  --ds-background-accent-orange-subtler-hovered: #A54800;
  --ds-background-accent-orange-subtler-pressed: #C25100;
  --ds-background-accent-orange-subtle: #A54800;
  --ds-background-accent-orange-subtle-hovered: #702E00;
  --ds-background-accent-orange-subtle-pressed: #38291E;
  --ds-background-accent-orange-bolder: #FEA362;
  --ds-background-accent-orange-bolder-hovered: #FEC195;
  --ds-background-accent-orange-bolder-pressed: #FEDEC8;
  --ds-background-accent-yellow-subtlest: #332E1B;
  --ds-background-accent-yellow-subtlest-hovered: #533F04;
  --ds-background-accent-yellow-subtlest-pressed: #7F5F01;
  --ds-background-accent-yellow-subtler: #533F04;
  --ds-background-accent-yellow-subtler-hovered: #7F5F01;
  --ds-background-accent-yellow-subtler-pressed: #946F00;
  --ds-background-accent-yellow-subtle: #7F5F01;
  --ds-background-accent-yellow-subtle-hovered: #533F04;
  --ds-background-accent-yellow-subtle-pressed: #332E1B;
  --ds-background-accent-yellow-bolder: #E2B203;
  --ds-background-accent-yellow-bolder-hovered: #F5CD47;
  --ds-background-accent-yellow-bolder-pressed: #F8E6A0;
  --ds-background-accent-green-subtlest: #1C3329;
  --ds-background-accent-green-subtlest-hovered: #164B35;
  --ds-background-accent-green-subtlest-pressed: #216E4E;
  --ds-background-accent-green-subtler: #164B35;
  --ds-background-accent-green-subtler-hovered: #216E4E;
  --ds-background-accent-green-subtler-pressed: #1F845A;
  --ds-background-accent-green-subtle: #216E4E;
  --ds-background-accent-green-subtle-hovered: #164B35;
  --ds-background-accent-green-subtle-pressed: #1C3329;
  --ds-background-accent-green-bolder: #4BCE97;
  --ds-background-accent-green-bolder-hovered: #7EE2B8;
  --ds-background-accent-green-bolder-pressed: #BAF3DB;
  --ds-background-accent-teal-subtlest: #1E3137;
  --ds-background-accent-teal-subtlest-hovered: #164555;
  --ds-background-accent-teal-subtlest-pressed: #206A83;
  --ds-background-accent-teal-subtler: #164555;
  --ds-background-accent-teal-subtler-hovered: #206A83;
  --ds-background-accent-teal-subtler-pressed: #227D9B;
  --ds-background-accent-teal-subtle: #206A83;
  --ds-background-accent-teal-subtle-hovered: #164555;
  --ds-background-accent-teal-subtle-pressed: #1E3137;
  --ds-background-accent-teal-bolder: #6CC3E0;
  --ds-background-accent-teal-bolder-hovered: #9DD9EE;
  --ds-background-accent-teal-bolder-pressed: #C6EDFB;
  --ds-background-accent-blue-subtlest: #1C2B41;
  --ds-background-accent-blue-subtlest-hovered: #09326C;
  --ds-background-accent-blue-subtlest-pressed: #0055CC;
  --ds-background-accent-blue-subtler: #09326C;
  --ds-background-accent-blue-subtler-hovered: #0055CC;
  --ds-background-accent-blue-subtler-pressed: #0C66E4;
  --ds-background-accent-blue-subtle: #0055CC;
  --ds-background-accent-blue-subtle-hovered: #09326C;
  --ds-background-accent-blue-subtle-pressed: #1C2B41;
  --ds-background-accent-blue-bolder: #579DFF;
  --ds-background-accent-blue-bolder-hovered: #85B8FF;
  --ds-background-accent-blue-bolder-pressed: #CCE0FF;
  --ds-background-accent-purple-subtlest: #2B273F;
  --ds-background-accent-purple-subtlest-hovered: #352C63;
  --ds-background-accent-purple-subtlest-pressed: #5E4DB2;
  --ds-background-accent-purple-subtler: #352C63;
  --ds-background-accent-purple-subtler-hovered: #5E4DB2;
  --ds-background-accent-purple-subtler-pressed: #6E5DC6;
  --ds-background-accent-purple-subtle: #5E4DB2;
  --ds-background-accent-purple-subtle-hovered: #352C63;
  --ds-background-accent-purple-subtle-pressed: #2B273F;
  --ds-background-accent-purple-bolder: #9F8FEF;
  --ds-background-accent-purple-bolder-hovered: #B8ACF6;
  --ds-background-accent-purple-bolder-pressed: #DFD8FD;
  --ds-background-accent-magenta-subtlest: #3D2232;
  --ds-background-accent-magenta-subtlest-hovered: #50253F;
  --ds-background-accent-magenta-subtlest-pressed: #943D73;
  --ds-background-accent-magenta-subtler: #50253F;
  --ds-background-accent-magenta-subtler-hovered: #943D73;
  --ds-background-accent-magenta-subtler-pressed: #AE4787;
  --ds-background-accent-magenta-subtle: #943D73;
  --ds-background-accent-magenta-subtle-hovered: #50253F;
  --ds-background-accent-magenta-subtle-pressed: #3D2232;
  --ds-background-accent-magenta-bolder: #E774BB;
  --ds-background-accent-magenta-bolder-hovered: #F797D2;
  --ds-background-accent-magenta-bolder-pressed: #FDD0EC;
  --ds-background-accent-gray-subtlest: #2C333A;
  --ds-background-accent-gray-subtlest-hovered: #38414A;
  --ds-background-accent-gray-subtlest-pressed: #454F59;
  --ds-background-accent-gray-subtler: #454F59;
  --ds-background-accent-gray-subtler-hovered: #596773;
  --ds-background-accent-gray-subtler-pressed: #738496;
  --ds-background-accent-gray-subtle: #596773;
  --ds-background-accent-gray-subtle-hovered: #454F59;
  --ds-background-accent-gray-subtle-pressed: #38414A;
  --ds-background-accent-gray-bolder: #8C9BAB;
  --ds-background-accent-gray-bolder-hovered: #9FADBC;
  --ds-background-accent-gray-bolder-pressed: #B6C2CF;
  --ds-background-disabled: #BCD6F00A;
  --ds-background-input: #22272B;
  --ds-background-input-hovered: #282E33;
  --ds-background-input-pressed: #22272B;
  --ds-background-inverse-subtle: #FFFFFF29;
  --ds-background-inverse-subtle-hovered: #FFFFFF3D;
  --ds-background-inverse-subtle-pressed: #FFFFFF52;
  --ds-background-neutral: #A1BDD914;
  --ds-background-neutral-hovered: #A6C5E229;
  --ds-background-neutral-pressed: #BFDBF847;
  --ds-background-neutral-subtle: #00000000;
  --ds-background-neutral-subtle-hovered: #A1BDD914;
  --ds-background-neutral-subtle-pressed: #A6C5E229;
  --ds-background-neutral-bold: #9FADBC;
  --ds-background-neutral-bold-hovered: #B6C2CF;
  --ds-background-neutral-bold-pressed: #C7D1DB;
  --ds-background-selected: #1C2B41;
  --ds-background-selected-hovered: #09326C;
  --ds-background-selected-pressed: #0055CC;
  --ds-background-selected-bold: #579DFF;
  --ds-background-selected-bold-hovered: #85B8FF;
  --ds-background-selected-bold-pressed: #CCE0FF;
  --ds-background-brand-subtlest: #1C2B41;
  --ds-background-brand-subtlest-hovered: #09326C;
  --ds-background-brand-subtlest-pressed: #0055CC;
  --ds-background-brand-bold: #579DFF;
  --ds-background-brand-bold-hovered: #85B8FF;
  --ds-background-brand-bold-pressed: #CCE0FF;
  --ds-background-brand-boldest: #E9F2FF;
  --ds-background-brand-boldest-hovered: #CCE0FF;
  --ds-background-brand-boldest-pressed: #85B8FF;
  --ds-background-danger: #42221F;
  --ds-background-danger-hovered: #5D1F1A;
  --ds-background-danger-pressed: #AE2E24;
  --ds-background-danger-bold: #F87168;
  --ds-background-danger-bold-hovered: #FD9891;
  --ds-background-danger-bold-pressed: #FFD5D2;
  --ds-background-warning: #332E1B;
  --ds-background-warning-hovered: #533F04;
  --ds-background-warning-pressed: #7F5F01;
  --ds-background-warning-bold: #F5CD47;
  --ds-background-warning-bold-hovered: #E2B203;
  --ds-background-warning-bold-pressed: #CF9F02;
  --ds-background-success: #1C3329;
  --ds-background-success-hovered: #164B35;
  --ds-background-success-pressed: #216E4E;
  --ds-background-success-bold: #4BCE97;
  --ds-background-success-bold-hovered: #7EE2B8;
  --ds-background-success-bold-pressed: #BAF3DB;
  --ds-background-discovery: #2B273F;
  --ds-background-discovery-hovered: #352C63;
  --ds-background-discovery-pressed: #5E4DB2;
  --ds-background-discovery-bold: #9F8FEF;
  --ds-background-discovery-bold-hovered: #B8ACF6;
  --ds-background-discovery-bold-pressed: #DFD8FD;
  --ds-background-information: #1C2B41;
  --ds-background-information-hovered: #09326C;
  --ds-background-information-pressed: #0055CC;
  --ds-background-information-bold: #579DFF;
  --ds-background-information-bold-hovered: #85B8FF;
  --ds-background-information-bold-pressed: #CCE0FF;
  --ds-blanket: #10121499;
  --ds-blanket-selected: #1D7AFC14;
  --ds-blanket-danger: #E3493514;
  --ds-interaction-hovered: #ffffff33;
  --ds-interaction-pressed: #ffffff5c;
  --ds-skeleton: #A1BDD914;
  --ds-skeleton-subtle: #BCD6F00A;
  --ds-chart-categorical-1: #2898BD;
  --ds-chart-categorical-1-hovered: #42B2D7;
  --ds-chart-categorical-2: #B8ACF6;
  --ds-chart-categorical-2-hovered: #DFD8FD;
  --ds-chart-categorical-3: #E56910;
  --ds-chart-categorical-3-hovered: #F38A3F;
  --ds-chart-categorical-4: #F797D2;
  --ds-chart-categorical-4-hovered: #FDD0EC;
  --ds-chart-categorical-5: #CCE0FF;
  --ds-chart-categorical-5-hovered: #E9F2FF;
  --ds-chart-categorical-6: #8270DB;
  --ds-chart-categorical-6-hovered: #8F7EE7;
  --ds-chart-categorical-7: #FDD0EC;
  --ds-chart-categorical-7-hovered: #FFECF8;
  --ds-chart-categorical-8: #FEC195;
  --ds-chart-categorical-8-hovered: #FEDEC8;
  --ds-chart-lime-bold: #82B536;
  --ds-chart-lime-bold-hovered: #94C748;
  --ds-chart-lime-bolder: #94C748;
  --ds-chart-lime-bolder-hovered: #B3DF72;
  --ds-chart-lime-boldest: #B3DF72;
  --ds-chart-lime-boldest-hovered: #D3F1A7;
  --ds-chart-neutral: #738496;
  --ds-chart-neutral-hovered: #8C9BAB;
  --ds-chart-red-bold: #E2483D;
  --ds-chart-red-bold-hovered: #F15B50;
  --ds-chart-red-bolder: #F15B50;
  --ds-chart-red-bolder-hovered: #F87168;
  --ds-chart-red-boldest: #FD9891;
  --ds-chart-red-boldest-hovered: #FFD5D2;
  --ds-chart-orange-bold: #F38A3F;
  --ds-chart-orange-bold-hovered: #FEA362;
  --ds-chart-orange-bolder: #FEA362;
  --ds-chart-orange-bolder-hovered: #FEC195;
  --ds-chart-orange-boldest: #FEC195;
  --ds-chart-orange-boldest-hovered: #FEDEC8;
  --ds-chart-yellow-bold: #CF9F02;
  --ds-chart-yellow-bold-hovered: #E2B203;
  --ds-chart-yellow-bolder: #E2B203;
  --ds-chart-yellow-bolder-hovered: #F5CD47;
  --ds-chart-yellow-boldest: #F5CD47;
  --ds-chart-yellow-boldest-hovered: #F8E6A0;
  --ds-chart-green-bold: #2ABB7F;
  --ds-chart-green-bold-hovered: #4BCE97;
  --ds-chart-green-bolder: #4BCE97;
  --ds-chart-green-bolder-hovered: #7EE2B8;
  --ds-chart-green-boldest: #7EE2B8;
  --ds-chart-green-boldest-hovered: #BAF3DB;
  --ds-chart-teal-bold: #42B2D7;
  --ds-chart-teal-bold-hovered: #6CC3E0;
  --ds-chart-teal-bolder: #6CC3E0;
  --ds-chart-teal-bolder-hovered: #9DD9EE;
  --ds-chart-teal-boldest: #9DD9EE;
  --ds-chart-teal-boldest-hovered: #C6EDFB;
  --ds-chart-blue-bold: #1D7AFC;
  --ds-chart-blue-bold-hovered: #388BFF;
  --ds-chart-blue-bolder: #388BFF;
  --ds-chart-blue-bolder-hovered: #579DFF;
  --ds-chart-blue-boldest: #85B8FF;
  --ds-chart-blue-boldest-hovered: #CCE0FF;
  --ds-chart-purple-bold: #8270DB;
  --ds-chart-purple-bold-hovered: #8F7EE7;
  --ds-chart-purple-bolder: #8F7EE7;
  --ds-chart-purple-bolder-hovered: #9F8FEF;
  --ds-chart-purple-boldest: #B8ACF6;
  --ds-chart-purple-boldest-hovered: #DFD8FD;
  --ds-chart-magenta-bold: #CD519D;
  --ds-chart-magenta-bold-hovered: #DA62AC;
  --ds-chart-magenta-bolder: #DA62AC;
  --ds-chart-magenta-bolder-hovered: #E774BB;
  --ds-chart-magenta-boldest: #F797D2;
  --ds-chart-magenta-boldest-hovered: #FDD0EC;
  --ds-chart-gray-bold: #738496;
  --ds-chart-gray-bold-hovered: #8C9BAB;
  --ds-chart-gray-bolder: #8C9BAB;
  --ds-chart-gray-bolder-hovered: #9FADBC;
  --ds-chart-gray-boldest: #9FADBC;
  --ds-chart-gray-boldest-hovered: #B6C2CF;
  --ds-chart-brand: #388BFF;
  --ds-chart-brand-hovered: #579DFF;
  --ds-chart-danger: #E2483D;
  --ds-chart-danger-hovered: #F15B50;
  --ds-chart-danger-bold: #FD9891;
  --ds-chart-danger-bold-hovered: #FFD5D2;
  --ds-chart-warning: #CF9F02;
  --ds-chart-warning-hovered: #E2B203;
  --ds-chart-warning-bold: #F5CD47;
  --ds-chart-warning-bold-hovered: #F8E6A0;
  --ds-chart-success: #2ABB7F;
  --ds-chart-success-hovered: #4BCE97;
  --ds-chart-success-bold: #7EE2B8;
  --ds-chart-success-bold-hovered: #BAF3DB;
  --ds-chart-discovery: #8270DB;
  --ds-chart-discovery-hovered: #8F7EE7;
  --ds-chart-discovery-bold: #B8ACF6;
  --ds-chart-discovery-bold-hovered: #DFD8FD;
  --ds-chart-information: #1D7AFC;
  --ds-chart-information-hovered: #388BFF;
  --ds-chart-information-bold: #85B8FF;
  --ds-chart-information-bold-hovered: #CCE0FF;
  --ds-surface: #1D2125;
  --ds-surface-hovered: #22272B;
  --ds-surface-pressed: #282E33;
  --ds-surface-overlay: #282E33;
  --ds-surface-overlay-hovered: #2C333A;
  --ds-surface-overlay-pressed: #38414A;
  --ds-surface-raised: #22272B;
  --ds-surface-raised-hovered: #282E33;
  --ds-surface-raised-pressed: #2C333A;
  --ds-surface-sunken: #161A1D;
  --ds-shadow-overflow: 0px 0px 12px #0304048F, 0px 0px 1px #03040480;
  --ds-shadow-overflow-perimeter: #03040480;
  --ds-shadow-overflow-spread: #0304048f;
  --ds-shadow-overlay: 0px 0px 0px 1px #39424a, 0px 8px 12px #0304045C, 0px 0px 1px 1px #03040480;
  --ds-shadow-raised: 0px 0px 0px 1px #00000000, 0px 1px 1px #03040480, 0px 0px 1px #03040480;
  --ds-opacity-disabled: 0.4;
  --ds-opacity-loading: 0.2;
  --ds-UNSAFE-transparent: transparent;
  --ds-elevation-surface-current: #1D2125;
}
`